// extracted by mini-css-extract-plugin
export var bounce = "ButtonAudit-module--bounce--e810b";
export var button = "ButtonAudit-module--button--0c479";
export var dotMoveLeft = "ButtonAudit-module--dot-move-left--41627";
export var dotMoveRight = "ButtonAudit-module--dot-move-right--f7f31";
export var gradient = "ButtonAudit-module--gradient--ef1d1";
export var separatorWidth = "ButtonAudit-module--separator-width--910bb";